import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import AuthCode from 'react-auth-code-input';
import { useOptionalField } from './FormikFields';
import { defaultInputStyleFunction } from './GenericInput';

const useInputStyles = createUseStyles(defaultInputStyleFunction);
const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase * 2,
    [theme.media.mobile]: {
      gap: theme.marginBase,
      flexWrap: 'wrap',
    },
  },
  input: {
    ...theme.fonts.h4,
    width: theme.height.regular,
    padding: 0,
    textAlign: 'center',
    [theme.media.mobile]: {
      ...theme.fonts.label,
      width: theme.height.small,
      minHeight: theme.height.regular,
      height: theme.height.regular,
    },
  },
}));

interface Props {
  length: number;
  name?: string;
  onChange: (value: string) => any;
  ariaLabel?: string;
}

export const CodeInput = ({ onChange, name, length = 3, ariaLabel }: Props) => {
  const theme: Theme = useTheme();
  const inputClasses: any = useInputStyles({ theme });
  const classes = useStyles({ theme });

  const { helpers } = useOptionalField({ name });

  const handleChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
    if (helpers && helpers.setValue) {
      helpers.setValue(value);
    }
  };

  return (
    <AuthCode
      containerClassName={classes.container}
      inputClassName={classnames(inputClasses.input, classes.input)}
      onChange={handleChange}
      length={length}
      ariaLabel={ariaLabel}
      autoFocus
    />
  );
};
